import { TApplicationState } from '../../types/redux';

export function getPromoLabelType(state: TApplicationState): string | null {
  const {
    newbuilding: { promoInfos },
  } = state;
  if (promoInfos && promoInfos.length) {
    return promoInfos[0].promoType;
  }

  return null;
}
